import React from 'react';
import { withStyles, Paper, Grid, Hidden, Typography } from '@material-ui/core';
import SolidBackdrop from '../misc/SolidBackdrop';
import ArrowButton from '../misc/ArrowButton';
import HeadlineText from '../misc/HeadlineText';
import DescriptionText from '../misc/DescriptionText';
import theme from '../../theme';
import { trackLink, AnalyticsConstants } from '../../../utilities/analyticsUtilities';
import Link from '../misc/Link';
import LazyLoader from '../misc/LazyLoader';
import { getConfigurationProperty } from '../../../configuration';

const styles = theme => ({
    section: {
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            padding: `${theme.spacing(4)}px 0`
		},
		[theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(8) * 1.5}px 0`
        },
        marginTop: 0,
        marginBottom: 0
    },
    image: {
        maxWidth: '100%'
    },
    descriptionText: {
        [theme.breakpoints.up('md')]: {
            textAlign: 'left',
        },
        [theme.breakpoints.down('sm')]: {
            padding: `0 ${theme.spacing(2)}px`
		},
    },
    emphasisText: {
        color: 'white'
    },
    spacer: {
        height: theme.spacing(12)
    }
});

const tryItId = 'index-screenshot-section-try-it-button';

class IndexScreenshotSection extends React.Component {
	render() {
		const { classes } = this.props;

        const headlineText = 'Easy to use Online Editor';
		return (
            <Grid
                container
                alignItems='center'
                spacing={4}
                className={classes.section}
            >
                <SolidBackdrop background='rgba(0,0,0,0.2)' />
                <SolidBackdrop
                    image='https://specterr.b-cdn.net/bg-wave3.svg'
                    color={theme.palette.background.darker1}
                    shadow
                />
                <Hidden mdUp>
                    <Grid 
                        item
                        xs={12}
                    >
                        <HeadlineText align='center'>
                            {headlineText}
                        </HeadlineText>
                    </Grid>
                </Hidden>
                <Grid 
                    item 
                    xs={12}
                    md={7}
                >
                    <Paper>
                        <LazyLoader
                            placeholder={<img
                                src='https://specterr.b-cdn.net/small.jpg'
                                className={classes.image}
                                alt='Screenshot of Specterr video creator suite.'
                            />}
                            offset={500}
                        >
                            <img
                                src='https://specterr.b-cdn.net/specterr-editor.JPG'
                                className={classes.image}
                                alt='Screenshot of Specterr video creator suite.'
                            />
                        </LazyLoader>
                    </Paper>
                </Grid>
                <Grid 
                    item
                    xs={12}
                    md={5}
                >
                    <Hidden smDown>
                        <Grid
                            container
                            alignItems='flex-start'
                            justify='center'
                            direction='column'
                            spacing={6}
                        >
                            <Grid item>
                                <HeadlineText>
                                    {headlineText}
                                </HeadlineText>
                            </Grid>
                            {this.renderCopyAndButons()}
                        </Grid>
                    </Hidden>
                    <Hidden mdUp>
                        <Grid
                            container
                            alignItems='center'
                            justify='center'
                            direction='column'
                            spacing={6}
                        >
                            {this.renderCopyAndButons()}
                        </Grid>
                    </Hidden>
                </Grid>
            </Grid>
		);
    }

    renderCopyAndButons = () => {
        const { classes } = this.props;

        return (<>
            <Grid item>
                <DescriptionText className={classes.descriptionText} >
                    <b className={classes.emphasisText}>No download needed</b>. Jump into the web based editor and start customizing right away. The live video preview updates in real time and moves with your music. 
                </DescriptionText>
            </Grid>
            <Grid item>
                <DescriptionText className={classes.descriptionText} >
                    <b className={classes.emphasisText}>It only takes a few minutes</b> to make a video. Use simple step based controls or dive deeper with advanced customization options. 
                </DescriptionText>
            </Grid>
            <Grid item>
                <Grid
                    container
                    alignItems='center'
                    justify='center'
                    direction='row'
                    spacing={3}
                >
                    <Grid item>
                        <ArrowButton
                            variant='outlined'
                            color='primary'
                            size='large'
                            className={classes.actionButton}
                            href={getConfigurationProperty('CreateVideoEndpoint')}
                            id={tryItId}
                        >
                            Try it
                        </ArrowButton>
                    </Grid>
                    {/* <Grid item>
                        <Link
                            to={'/music-video-editor/'}
                            color='textSecondary'
                            underline='always'
                        >
                            <Typography
                                variant='body2'
                            >
                                Learn More
                            </Typography>
                        </Link>
                    </Grid> */}
                </Grid>
                
            </Grid>
        </>);
    }
    
    componentDidMount() {
		setTimeout(() => {
			trackLink(tryItId, 'Clicked CTA', {
				location: 'home screenshot',
				destination: 'create',
				color: 'red',
				text: 'TRY IT',
				type: 'button',
				category: AnalyticsConstants.ACQUISITION_CATEGORY
			});
		}, 100);
	}
}

export default withStyles(styles)(IndexScreenshotSection);